import RenderCabinets from "./renderCabinets";
import sqftConfig from "../store/sqftConfig";
import {
  getParallelPoints,
  getPointBetweenPoints,
  getPointOnTheLine,
  rotatePoint,
  getPointDistance,
  measureDistanceToInches, addDecimalToLength
} from "../../../helpers/sqftHelper";
import workspace from "../core/workspace";
import {attachResource} from "../core/controls/resourseCanas";
import {MEASURE_UNITS, RESOURCE_ATTACHED_TO_TYPE} from "../../../constants";
import workspaceControllers from "../store/workspaceControllers";
import {areCollinearAndOverlap, calculateLeg, roundShapePoints} from "../../../helpers/coordinatesHelper";
import {DIRECTIONS} from "../../../helpers/shapeHelper";
import Point from "../core/shapes/point";
import Line from "../core/shapes/line";

/**
 * @param line {{}}
 * @return {PointV2}
 */
export const getLineCrownMoldingPoints = (line) => {
  const linePointsIds = [
    line.from.id,
    line.to.id,
  ]
  const shapePoints = line.getParent().getPointsPointField();

  return RenderCabinets.getDiagonalPointsForTheLine(shapePoints, sqftConfig.crownMoldingParams.distance, linePointsIds);
}

/**
 * @param point1 {point}
 * @param point2 {point}
 * @param outlineDistance {int}
 * @return {[]}
 */
export const getLineBordersArrayV1 = (point1, point2, outlineDistance) => {
  const pointField1 = point1.getPointField(false);//point1 instanceof PointV2 ? point1.getPointField(false) : getPointField(point1.x, point1.y, point1.getParent());
  const pointField2 = point2.getPointField(false);//point2 instanceof PointV2 ? point2.getPointField() : getPointField(point2.x, point2.y, point2.getParent());
  const pointOnTheLine = getPointOnTheLine(pointField1, pointField2, outlineDistance);
  const pointOnTheLine2 = getPointOnTheLine(pointField2, pointField1, outlineDistance);
  return [
    rotatePoint(pointField1, pointOnTheLine, 90),
    rotatePoint(pointField1, pointOnTheLine, -90),
    rotatePoint(pointField2, pointOnTheLine2, 90),
    rotatePoint(pointField2, pointOnTheLine2, -90)
  ];
}

/**
 * @param point1 {point}
 * @param point2 {point}
 * @param outlineDistance {int}
 * @return {[]}
 */
export const getLineBordersArrayV2 = (point1, point2, outlineDistance) => {
  const pointField1 = point1.getPointField(false);//point1 instanceof PointV2 ? point1.getPointField(false) : getPointField(point1.x, point1.y, point1.getParent());
  const pointField2 = point2.getPointField(false);//point2 instanceof PointV2 ? point2.getPointField() : getPointField(point2.x, point2.y, point2.getParent());
  const [parallelPoint1, parallelPoint2] = getParallelPoints(pointField1, pointField2, outlineDistance);
  const [parallelPoint4, parallelPoint3] = getParallelPoints(pointField1, pointField2, -outlineDistance);
  return [
    parallelPoint1,
    parallelPoint2,
    parallelPoint3,
    parallelPoint4
  ];
}


/**
 * @param from {point}
 * @param to {point}
 * @param lineThickness {int}
 * @return {[]}
 */
export const getBordersOfTwoPoints = (from, to, lineThickness) => {
  const lineBorderArray = getLineBordersArrayV2(from, to, lineThickness);

  //console.log("lineBorderArray", lineBorderArray);
  let virtualLines = [];
  for (const borderPointKey in lineBorderArray) {
    const len = lineBorderArray.length;
    const currentLineBorderPoint = lineBorderArray[+borderPointKey];
    //const previousLineBorderPoint = lineBorderArray[(lineBorderPointIndex + len - 1) % len];
    const nextLineBorderPoint = lineBorderArray[(+borderPointKey + 1) % len];
    let virtualLine = {
      from: {
        ...currentLineBorderPoint,
        modelCorePoint: {
          getPosX: function () { return currentLineBorderPoint.x },
          getPosY: function () { return currentLineBorderPoint.y }
        },
        getPointField: function () { return currentLineBorderPoint }
      },
      to: {
        ...nextLineBorderPoint,
        modelCorePoint: {
          getPosX: function () { return nextLineBorderPoint.x },
          getPosY: function () { return nextLineBorderPoint.y }
        },
        getPointField: function () { return nextLineBorderPoint }
      },
      getOffset: () => {
        return this.getOffset()
      }
    }
    virtualLines.push(virtualLine);
  }

  return virtualLines
}

export const addEdgeToTheLines = (shapeId, edge, lineNumbers, shouldShowEyeBall = true) => {
  const shape = workspace.getShapeById(shapeId);
  const lines = shape.getLines();

  lines.forEach((line, index) => {
    if (lineNumbers.includes(index)) {
      //line.addEdgeToLine(edge.getFeatureName(), edge.dbFeature.id); // old functional
      attachResource(line,
        null,
        RESOURCE_ATTACHED_TO_TYPE.edge,
        edge.dbFeature.id,
        null,
        edge.getFeatureName(),
        0,
        null,
        null,
        true,
        shouldShowEyeBall)
    }
  })
}

/**
 * Add Edge Without feature for the slab and material calculation
 * @param shapeId
 * @param lineNumbers
 */
export const addFakeEdgeToLines = (shapeId, lineNumbers) => {
  const shape = workspace.getShapeById(shapeId);
  const lines = shape.getLines();

  lines.forEach((line, index) => {
    if (lineNumbers.includes(index)) {
      line.setFakeEdge(true);
    }
  })
}

export const setLineParams = (shapeId, lineNumbers, params) => {
  const shape = workspace.getShapeById(shapeId);
  const lines = shape.getLines();

  lines.forEach((line, index) => {
    if (lineNumbers.includes(index)) {
      line.setStateParams(params);
    }
  })
}

export const updateShapeWaterfallLength = (line) => {
  const shape = line.getParent();
  for (const shapeLine of shape.getLines()) {
    if (shapeLine.isWithWaterfallToolEdge() || shapeLine.isWithPeninsulaUnderwrapEdge()) {
      workspaceControllers.waterfall.updateWaterfallLength(shapeLine);
    }
  }
}

export const updateMiteredLength = (line) => {
  const shape = line.getParent();
  for (const shapeLine of shape.getLines()) {
    if (shapeLine.isWithMitered()) {
      shapeLine.miteredOverlay.setNewLineWidth();
    }
  }
}

export const updateUnderlaymentLength = (line) => {
  const shape = line.getParent();
  for (const shapeLine of shape.getLines()) {
    if (shapeLine.isWithUnderlayment()) {
      shapeLine.underlaymentOverlay.setNewLineWidth();
    }
  }
}

/**
 *
 * @param points[]
 * @return lines[{}]
 */
export const createSimpleLinesFromPoints = (points) => {
  let lines = [];

  for (let i = 0; i < points.length; i++) {
    let line = {
      from: points[i],
      to: points[(i + 1) % points.length]
    };
    lines.push(line);
  }

  return lines;
};

export const initAllLineLength = () => {
  const lines = workspace.getLines();
  for (const line of lines) {
    if (line.overlay) {
      line.overlay.reInitEvents();
    }
  }
}

export const hideAllLineLength = () => {
  const lines = workspace.getLines();
  for (const line of lines) {
    if (line.overlay) {
      line.overlay.deregisterEvents();
    }
  }
}

export const findCollinearLine = (searchLine) => {
  const lines = workspace.getLines();
  const roundedSearchLinePoints = roundShapePoints([searchLine.from.getPointPosOnWorkspace(), searchLine.to.getPointPosOnWorkspace()]);
  for (const testLine of lines) {
    const roundedTestPoints = roundShapePoints([testLine.from.getPointPosOnWorkspace(), testLine.to.getPointPosOnWorkspace()]);
    if (areCollinearAndOverlap(roundedSearchLinePoints[0], roundedSearchLinePoints[1], roundedTestPoints[0], roundedTestPoints[1], 1)) {
      return testLine
    }
  }
}

export const isHorizontalDirection = (lineDirection) => {
  return [DIRECTIONS.WEST, DIRECTIONS.EAST].includes(lineDirection)
}

export const isVerticalDirection = (lineDirection) => {
  return [DIRECTIONS.NORTH, DIRECTIONS.SOUTH].includes(lineDirection)
}

export const isWesternHemisphere = (lineDirection) => {
  return [DIRECTIONS.WEST, DIRECTIONS.NORTHWEST, DIRECTIONS.NORTH, DIRECTIONS.NORTHEAST].includes(lineDirection);
}

export const isEasternHemisphere = (lineDirection) => {
  return [DIRECTIONS.EAST, DIRECTIONS.SOUTHWEST, DIRECTIONS.SOUTH, DIRECTIONS.SOUTHEAST].includes(lineDirection);
}

/**
 *
 */
export const getLinesWithoutAnglePoints = (lines) => {
  const adjustedLines = [];

  lines.forEach((line) => {
    if (line.to.angle > 0 && line.from.angle > 0) {
      // Both 'to' and 'from' have angles, adjust both points
      const legLengthTo = calculateLeg(line.to.angle);
      const legLengthFrom = calculateLeg(line.from.angle);

      // Calculate new points for 'to' and 'from'
      const linePosTo = getPointBetweenPoints(line.to, line.from, legLengthFrom, -2);
      const linePointTo = new Point(linePosTo.x, linePosTo.y);

      const linePosFrom = getPointBetweenPoints(line.from, line.to, legLengthFrom, -2);
      const linePointFrom = new Point(linePosFrom.x, linePosFrom.y);

      // Add current line resized
      const cloneLine = { ...line };
      cloneLine.to = linePointTo;
      cloneLine.from = linePointFrom;
      adjustedLines.push(cloneLine);

      // Create adjusted line
      const nextLine = line.getParent().getNextLine(line);
      const newLinePosFrom = getPointBetweenPoints(nextLine.from, nextLine.to, legLengthTo, -2);
      const newLinePointFrom = new Point(newLinePosFrom.x, newLinePosFrom.y);

      adjustedLines.push(new Line(linePointTo, newLinePointFrom, line.getParent()));

      debugger // eslint-disable-line no-debugger
    } else if (line.to.angle > 0) {
      // Only 'to' has an angle
      const legLength = calculateLeg(line.to.angle);
      const newLinePosFrom = getPointBetweenPoints(line.to, line.from, legLength, -2);
      const newLinePointFrom = new Point(newLinePosFrom.x, newLinePosFrom.y);

      const nextLine = line.getParent().getNextLine(line);
      const newLinePosTo = getPointBetweenPoints(nextLine.from, nextLine.to, legLength, -2);
      const newLinePointTo = new Point(newLinePosTo.x, newLinePosTo.y);

      // Add current line resized
      const cloneLine = { ...line };
      cloneLine.to = newLinePointFrom;
      adjustedLines.push(cloneLine);

      // Create adjusted line
      adjustedLines.push(new Line(newLinePointFrom, newLinePointTo, line.getParent()));

    } else if (line.from.angle > 0) {
      // Only 'from' has an angle
      const legLength = calculateLeg(line.from.angle);
      const newLinePosTo = getPointBetweenPoints(line.from, line.to, legLength, -2);
      const newLinePointTo = new Point(newLinePosTo.x, newLinePosTo.y);

      const cloneLine = { ...line };
      cloneLine.from = newLinePointTo;
      adjustedLines.push(cloneLine);

    } else {
      // No angles, add line as is
      adjustedLines.push(line);
    }
  });

  return adjustedLines;
};


/**
 * Function to find the longest line in an array of lines.
 * @param {Array} lines - Array of lines where each line has properties from and to.
 * @returns {Object} The longest line object.
 */
export function findLongestLine(lines) {
  if (!lines || lines.length === 0) {
    return null;
  }

  let longestLine = lines[0];
  let maxLength = getPointDistance(longestLine.from, longestLine.to);

  lines.forEach(line => {
    const length = getPointDistance(line.from, line.to);
    if (length > maxLength) {
      maxLength = length;
      longestLine = line;
    }
  });

  return longestLine;
}

export function getDistanceLength(distance) {
  switch (sqftConfig.measureUnit) {
    case MEASURE_UNITS.Metric:
      return measureDistanceToInches(distance).millimeters
    case MEASURE_UNITS.Imperial:
    default:
      return addDecimalToLength(measureDistanceToInches(distance))
  }
}
